import React from "react";
import { AwardIcon, BedDoubleIcon, BriefcaseIcon, Building2Icon, BuildingIcon, ClipboardCheckIcon, DoorOpenIcon, DropletsIcon, FlameIcon, HammerIcon, HardHatIcon, HomeIcon, KeyRoundIcon, PaintRollerIcon, ShieldCheckIcon, SofaIcon, BoxIcon } from "lucide-react";
const iconMap: Record<string, BoxIcon> = {
  award: AwardIcon,
  bedDouble: BedDoubleIcon,
  briefcase: BriefcaseIcon,
  building: BuildingIcon,
  building2: Building2Icon,
  clipboardCheck: ClipboardCheckIcon,
  doorOpen: DoorOpenIcon,
  droplets: DropletsIcon,
  flame: FlameIcon,
  hammer: HammerIcon,
  hardHat: HardHatIcon,
  home: HomeIcon,
  keyRound: KeyRoundIcon,
  paintRoller: PaintRollerIcon,
  shield: ShieldCheckIcon,
  sofa: SofaIcon
};
type IconProps = {
  name: string;
  className?: string;
};
export function Icon({
  name,
  className
}: IconProps) {
  const Component = iconMap[name] ?? ShieldCheckIcon;
  return <Component className={className} aria-hidden="true" data-id="element-316" data-mp="100p1j2l30nbk" />;
}